import Layout from "../layouts/LayoutDefault.jsx";
import MakeGetRequest from "../components/utils/MakeGetRequest.jsx";
import MainContainer from "../components/MainContainer";
import EventCard from "../components/EventCard.jsx";
import TitleTextSection from "../components/TitelTextSection.jsx";
import CommercialBanner from "../components/CommercialBanner.jsx";

const CARDS_COUNT = 6;
const TOTAL_LIMIT = 100;

const formatDate = (dateString) => {
  if (!dateString) return "Datum saknas";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Ogiltigt datum";
  return date.toLocaleDateString("sv-SE", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const EventsPage = () => {
  const { data, error, loading } = MakeGetRequest({
    route: `get_events?page=1&limit=${TOTAL_LIMIT}`,
    errorCodeRedirect: 404,
  });

  const seoTitle = "Events - Hitta ett lokalt event";
  const seoDescription =
    "Upptäck lokala evenemang i Strängnäs kommun med Lokult. Hitta konserter, festivaler och kulturella händelser nära dig.";

  if (loading) {
    return (
      <Layout title={seoTitle} description={seoDescription}>
        <MainContainer>
          <div className="text-center my-20">
            <h1 className="text-2xl font-bold">Laddar...</h1>
            <p>Vänligen vänta medan evenemangen laddas.</p>
          </div>
        </MainContainer>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout title={seoTitle} description={seoDescription}>
        <MainContainer>
          <div className="text-center my-20">
            <h1 className="text-2xl font-bold">Något gick fel</h1>
            <p className="text-neutral-content mt-2">
              Försök igen senare eller kontakta supporten.
            </p>
          </div>
        </MainContainer>
      </Layout>
    );
  }

  const events = data?.items || [];
  const totalCount = data?.count || 0;
  const cardEvents = events.slice(0, CARDS_COUNT);
  const listEvents = events.slice(CARDS_COUNT);

  return (
    <Layout title={seoTitle} description={seoDescription}>
      <MainContainer>
        <div className="pb-4">
          <div className="sm:py-4 flex justify-between items-center">
            <TitleTextSection
              title="Evenemang"
              subtitle={`${totalCount} kommande evenemang i Strängnäs kommun`}
            />
          </div>

          {cardEvents.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {cardEvents.map((event, index) => (
                <div key={event.slug || index} className="grid col-span-1">
                  <EventCard event={event} />
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <p className="text-xl text-neutral-content">
                Inga kommande evenemang just nu.
              </p>
              <p className="text-neutral-content mt-2">
                Kom tillbaka senare för att se nya evenemang!
              </p>
            </div>
          )}
        </div>

        {cardEvents.length > 5 && <CommercialBanner />}

        {listEvents.length > 0 && (
          <div className="pb-4 mt-4">
            <div className="sm:py-4">
              <TitleTextSection
                title="Fler evenemang"
                subtitle="Kommande evenemang längre fram"
              />
            </div>
            <div className="divide-y divide-white/5 bg-[#131313] border border-white/10 rounded-2xl p-4 shadow-lg flex flex-col gap-1">
              {listEvents.map((event, index) => (
                <a
                  key={event.slug || index}
                  href={`/events/${event.slug}`}
                  className="flex items-center justify-between py-3.5 px-4 hover:bg-neutral-900/60 rounded-xl transition-all duration-200 group border border-transparent hover:border-white/5"
                >
                  <span className="text-sm sm:text-base font-extrabold text-white uppercase tracking-wide group-hover:text-[#0047ff] transition-colors">
                    {event.name}
                  </span>
                  <span className="text-xs font-semibold text-stone-400 whitespace-nowrap ml-4">
                    {formatDate(event.date)}
                  </span>
                </a>
              ))}
            </div>
          </div>
        )}
      </MainContainer>
    </Layout>
  );
};

export default EventsPage;
